import { render, staticRenderFns } from "./CustomizeMetalAR.vue?vue&type=template&id=06bdc5a8&scoped=true"
import script from "./CustomizeMetalAR.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAR.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAR.vue?vue&type=style&index=0&id=06bdc5a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdc5a8",
  null
  
)

export default component.exports